import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { immunity } from "../../../../constants";


export default function ImmunityCard() {
  

return (

    <CardImageMarkers 
    
        image={immunity}
        title="IMMUNITY & HEMATOLOGY"
        subtitle="Monitor your immunity health"
        markersTitle=""
        markers="WBC, RBC, HGB
                HCT, MCV, MCH – habe,
                MCHC – HGB/HCT, RDW, PLT,
                Diff. Blood: Neutrophils, Lymphocytes,
                Monocytes, Eosinophils, Basophils


                "

    />


)
}